import { Tag } from 'antd';

import { DokobitLogin, useUser } from '@/features/auth';
import { setDocumentTitle } from '@/helpers/document';
import { useUserInfoStore } from '@/store';
import { cn } from '@/utils/cn';

export const formatRole = (role: string): string =>
  role
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');

const MainPage = () => {
  setDocumentTitle('EKT iseteenindus');
  const { data: user } = useUser();
  const { selectedAccount } = useUserInfoStore();

  return (
    <div
      className={cn('h-full flex flex-col items-center pt-10', {
        'justify-center': !user,
      })}
    >
      {user ? (
        <>
          {import.meta.env.VITE_APP_ENV === 'staging' ? (
            <>
              <span className="text-3xl font-bold">Welcome</span> {user.fullName}
              <div className="flex flex-col mt-5 gap-y-4">
                <div className="flex items-center gap-x-2">
                  <span className="text-lg font-medium">Your role(s):</span>
                  <div className="flex flex-wrap gap-2">
                    {user.roles.map((role) => (
                      <Tag.CheckableTag key={role} checked={true} className="text-lg cursor-default">
                        {formatRole(role)}
                      </Tag.CheckableTag>
                    ))}
                  </div>
                </div>
                <div className="flex items-center gap-x-2">
                  <span className="text-lg font-medium">in account:</span>
                  <span className="px-3 py-1 text-lg font-bold text-blue-600 rounded-md bg-blue-50">{selectedAccount?.name}</span>
                </div>
              </div>
            </>
          ) : (
            <></>
          )}
        </>
      ) : (
        <DokobitLogin />
      )}
    </div>
  );
};

export default MainPage;
